<template>
  <div class="app-modal-dialog--bulk-exports app-modal-dialog">
    <slot></slot>
    <div class="app-modal-dialog__content">
      <div class="app-modal-dialog__header">
          <h2 class="app-modal-dialog__title">Create New Bulk Export</h2>
      </div>
      <div class="app-modal-dialog__body grid">
        <div class="col-12 col-sm-6">
          <div class="input select">
            <label>Export Type</label>
            <select
              v-model="selectedType">
              <option :value="null" selected>Select type</option>
              <option v-for="(option, index) in options" :key="`option-${index}`" :value="option.value">
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
        <form  v-if="showList" @submit.prevent="search" class="col-12">
          <div class="app-search">
            <div class="input text">
              <label>Search</label>
              <input
                type="search"
                placeholder="Search for keywords or phrases"
                v-model="input"
                @search="onSearch"
                required>
            </div>
            <button
              type="submit"
              class="element-button--secondary element-button"
              :disabled="loading">
              Search
            </button>
          </div>
        </form>

        <div class="app-modal-dialog__results col-12" v-if="showList">
          <p>Total results: {{ totalCount }}</p>
          <p>Total selected: {{ publicationCollection.length }}</p>
          <div class="app-modal-dialog__message">
            <div v-show="loading" class="app-loader__wrapper">
              <app-loader />
            </div>
            <span class="inline-message is--error" v-if="error">{{ error }}</span>
            <span class="inline-message" v-else-if="status">{{ status }}</span>
          </div>
        </div>

        <div class="col-12" v-if="showList">
          <app-paginator
            :items="filteredResults"
            :items-per-page="itemsPerPage"
            class="app-modal-dialog__filtered-results">
            <template v-slot:item="paging">
              <div
                :key="`learning-${paging.item.id}`"
                class="checkbox">
                <input
                  type="checkbox"
                  class="checkbox__input"
                  v-model="publicationCollection"
                  :id="paging.item.id"
                  :value="paging.item.id">
                <label :for="paging.item.id">
                  {{ paging.item.name }}
                </label>
              </div>
            </template>
          </app-paginator>
        </div>
      </div>
      <div class="app-modal-dialog__footer">
        <a href="../bulkprocess" class="element-button--secondary element-button">Cancel</a>
        <app-button
          :disabled="!canCreate"
          theme="primary"
          @click="createBulkProcess()">
          Submit
        </app-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import api from '../api/publisher'

export default {
  props: {
    project: {
      type: Object
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsPerPage: {
      type: Number,
      default: 50
    }
  },
  data () {
    const options = [
      { text: 'Export Selected Course Scripts', value: { type: 'script', all: false } },
      { text: 'Export Selected Course Packages', value: { type: 'package', all: false } },
      { text: 'Export All Course Scripts', value: { type: 'script', all: true } },
      { text: 'Export All Course Packages', value: { type: 'package', all: true } },
      { text: 'Export All Course Assets', value: { type: 'asset-csv', all: true } },
    ]

    return {
      input: '',
      query: '',
      loading: false,
      status: false,
      error: false,
      matches: [],
      publicationCollection: [],
      selectedType: options[0].value,
      isProcessing: false,
      options
    }
  },
  computed: {
    filteredResults () {
      let filtered = this.items

      if (this.query.length) {
        filtered = _.filter(this.items, (publication) => {
          return _.find(this.matches, { id: publication.id })
        })
      }

      return _.sortBy(filtered, 'name')
    },
    totalCount () {
      return this.filteredResults.length
    },
    canCreate () {
      return this.selectedType && (this.selectedType.all || this.publicationCollection.length > 0)
    },
    showList () {
      return !this.selectedType?.all
    }
  },
  methods: {
    onSearch () {
      this.query = this.input
      this.matches = []
    },
    async search () {
      this.setStatus(`Searching for: "${this.input}"`)

      this.query = this.input

      try {
        const response = await axios.get(
          `/projects/${this.project.id}/bulkprocess/selection`,
          { params: { search: this.query } }
        )
        this.matches = _.get(response, 'data.data.publications')
      } catch (err) {
        this.displayError(err, `Error getting search results for: "${this.query}"`)
      }

      if (this.filteredResults.length) {
        this.setStatus(`Showing results for: "${this.query}"`, false)
      } else {
        this.setStatus('No results.', false)
      }
    },
    setStatus(status, loading = true) {
      this.loading = loading
      this.status = status
    },
    clearStatus(loading = false) {
      this.status = false
      this.loading = loading
    },
    displayError(err, genericMessage) {
      console.error(err)
      const errors = _.get(err, 'response.data.errors', false)
      this.error = errors[0] || genericMessage
    },
    async createBulkProcess () {
      this.isProcessing = true

      const items = !this.selectedType.all ? this.publicationCollection : []
  
      if (this.selectedType.type === 'package') {
        await api.bulkPackage(this.project.id, items)
      } else if (this.selectedType.type === 'script') {
        await api.bulkExport(this.project.id, items)
      } else if (this.selectedType.type === 'asset-csv') {
        await api.bulkAssetExport(this.project.id, items)
      }

      this.isProcessing = false
    }
  }
}
</script>
